import { Form, Input, Icon, Button } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import React from 'react';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import UserEndpoint from '../../core-module/models/LoopBack/Models/UserEndpoint';

interface Props extends FormComponentProps {
  loopBackEndpoint: UserEndpoint;
  visible: boolean;
  onModeChange: (value: string) => void;
  token: string;
}

interface State {
  loading: boolean;
  password: string;
  passwordRepeat: string;
}

class ResetPasswordRequestForm extends React.Component<Props, State> {
  loopBackEndpoint: UserEndpoint;

  constructor(props) {
    super(props);
    this.loopBackEndpoint = new UserEndpoint();
    this.state = {
      loading: false,
      password: '',
      passwordRepeat: ''
    };
  }
  handleSubmit = () => {
    this.props.form.validateFields((errors, values) => {
      if (!errors) {
        this.setState({ loading: true });
        this.loopBackEndpoint
          .resetPassword({ newPassword: values.password }, this.props.token)
          .then(() => {
            this.setState({ loading: false });
            Swal({
              title: 'Wachtwoord opgeslagen',
              text: `Je wachtwoord is succesvol aangepast`,
              type: 'success',
              confirmButtonText: 'Ok'
            }).then((result) => {
              this.props.onModeChange('login');
            });
          })
          .catch(() => {
            this.setState({ loading: false });
            Swal({
              title: 'Helaas',
              text: `Er is iets mis gegaan bij het opslaan van het nieuwe wachtwoord`,
              type: 'error',
              confirmButtonText: 'Ok'
            }).then((result) => {});
          });
      }
    });
  };

  validatePassword() {
    if (this.state.password !== this.state.passwordRepeat) {
      this.props.form.setFields({
        password: {
          value: this.state.password,
          errors: [new Error('Wachtwoorden komen niet overeen')]
        },
        password_repeat: {
          value: this.state.passwordRepeat,
          errors: [new Error('Wachtwoorden komen niet overeen')]
        }
      });
    } else {
      this.props.form.setFields({
        password: {
          value: this.state.password,
          errors: undefined
        },
        password_repeat: {
          value: this.state.passwordRepeat,
          errors: undefined
        }
      });
    }
  }

  setPasswordState(value: string, key: string) {
    switch (key) {
      case 'password':
        this.setState({ password: value }, () => this.validatePassword());
        return;
      case 'passwordRepeat':
        this.setState({ passwordRepeat: value }, () => this.validatePassword());
        return;
      default:
        return;
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form className='login-form'>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Voer een nieuw wachtwoord in' }]
          })(
            <Input
              type={'password'}
              onChange={(e) => this.setPasswordState(e.target.value, 'password')}
              placeholder={'Wachtwoord'}
              size={'large'}
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password_repeat', {
            rules: [{ required: true, message: 'Voer een nieuwe wachtwoord in' }]
          })(
            <Input
              type={'password'}
              onChange={(e) => this.setPasswordState(e.target.value, 'passwordRepeat')}
              placeholder={'Wachtwoord herhalen'}
              size={'large'}
            />
          )}
        </Form.Item>
        <Form.Item>
          <Button
            htmlType={'button'}
            type={'primary'}
            className='login-form-button'
            onClick={this.handleSubmit}
          >
            {this.state.loading && (
              <Icon type='loading' style={{ fontSize: 24, color: 'white' }} spin />
            )}
            Opslaan
          </Button>
          <Button
            style={{ marginLeft: 5 }}
            htmlType={'button'}
            className='login-form-button'
            onClick={() => this.props.onModeChange('login')}
          >
            Annuleren
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const mapStateToProps = () => ({});

export default connect<any, any, any>(
  null,
  mapStateToProps
)(Form.create()(ResetPasswordRequestForm));
